export default __webpack_public_path__ + "static/media/sqlorg.42af4927.png";